import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import axios from 'axios'
import { apiUrl } from '@/apiUrl'
import { generalLib } from '@/generalLib'
import { customerColorMap } from '@/customerColorMap'

import HomeBase from '../views/HomeBase.vue'
import HomeDipendente from '../views/HomeDipendente.vue'
import LoginForm from '../views/LoginForm.vue'
import ReconnectLogin from '../views/ReconnectLogin.vue'
import TokenLogin from '../views/TokenLogin.vue'
import PasswordReset from '../views/PasswordReset.vue'
import DashMovimenti from '../views/DashMovimenti.vue'
import UserProfile from '../views/UserProfile.vue'
import PageNotFound from '../views/PageNotFound.vue'
import NestedRouteRoot from '../views/NestedRouteRoot.vue'
import ConvRedirect from '../views/ConvRedirect.vue'

// Forms Richieste Welfare
import PreventivoOnDemand from '../views/WelfareForms/PreventivoOnDemand.vue'
import RimborsoSpese from '../views/WelfareForms/RimborsoSpese.vue'
import RimborsoInteressi from '../views/WelfareForms/RimborsoInteressi.vue'
import RimborsoBollette from '../views/WelfareForms/RimborsoBollette.vue'
import RimborsoAffMutui from '../views/WelfareForms/RimborsoAffMutui.vue'
import PrevidenzaIntegrativa from '../views/WelfareForms/PrevidenzaIntegrativa.vue'

// Tantosvago
import TsExperience from '../views/Tantosvago/TsExperience.vue'
import TsTravel from '../views/Tantosvago/TsTravel.vue'
import TsTravelB from '../views/Tantosvago/TsTravelB.vue'
import TsGiftcard from '../views/Tantosvago/TsGiftcard.vue'
import TsGoWelfare from '../views/Tantosvago/TsGoWelfare.vue'
import TsTicket from '../views/Tantosvago/TsTicket.vue'
import TsHomeActivities from '../views/Tantosvago/TsHomeActivities.vue'
import TsAmzLibri from '../views/Tantosvago/TsAmzLibri.vue'
import SalabamBooking from '../views/Salabam/SalabamBooking.vue'
import TsAssirete from '../views/Tantosvago/TsAssirete.vue'
import TsWelcomeToItaly from '../views/Tantosvago/TsWelcomeToItaly.vue'
import TsSnowIt from '../views/Tantosvago/TsSnowIt.vue'
import TsEatinerari from '../views/Tantosvago/TsEatinerari.vue'
import TsEdicola from '../views/Tantosvago/TsEdicola.vue'

// WishList
import WishListLogin from '../views/WishList/WishListLogin.vue'

// Amilon
import HomeAmilon from '../views/Amilon/HomeAmilon.vue'
import VetrinaFornAmilon from '../views/Amilon/VetrinaFornAmilon.vue'
import BonusCarburante from '../views/Amilon/BonusCarburante.vue'

// Amilon 100
import AmlExpedia from '../views/Amilon100/AmlExpedia.vue'
import AmlHoepli from '../views/Amilon100/AmlHoepli.vue'

// Eurete
import HomeEurete from '../views/Eurete/HomeEurete.vue'
import VetrinaEurete from '../views/Eurete/VetrinaEurete.vue'
import VetrinaEurete100 from '../views/Eurete/VetrinaEurete100.vue'

// Fano Al Centro
import FacLoginPage from '../views/FanoAlCentro/FacLoginPage.vue'

// MBA
import MBALoginPage from '../views/MBA/MBALoginPage.vue'

// Salute Semplice
import SaluteSempliceLoginPage from "../views/SaluteSemplice/SaluteSempliceLoginPage.vue";

// BitQ
import BitQParchi from '../views/BitQ/BitQParchi.vue'
import BitQEsperienze from '../views/BitQ/BitQEsperienze.vue'
import BitQTour from '../views/BitQ/BitQTour.vue'
import BitQSport from '../views/BitQ/BitQSport.vue'
import BitQMusei from '../views/BitQ/BitQMusei.vue'
import BitQCinema from '../views/BitQ/BitQCinema.vue'
import BitQConcerti from '../views/BitQ/BitQConcerti.vue'
import BitQGaming from '../views/BitQ/BitQGaming.vue'
import BitQCorsi from '../views/BitQ/BitQCorsi.vue'

// Salabam
import SalabamShop from '../views/Salabam/SalabamShop.vue'
import SalabamVadobay from '../views/Salabam/SalabamVadobay.vue'
import SalabamVoliVadobay from '../views/Salabam/SalabamVoliVadobay.vue'
import SalabamVacanzeVadobay from '../views/Salabam/SalabamVacanzeVadobay.vue'
import SalabamVivamod from '../views/Salabam/SalabamVivamod.vue'
import SalabamTravelTrain from '../views/Salabam/SalabamTravelTrain.vue'
import SalabamWiaggiare from '../views/Salabam/SalabamWiaggiare.vue'

// OlliPay
import OlliPay from '../views/OlliPay/OlliPay.vue'

// Toduba
import ToDuBa from '../views/ToDuBa/ToDuBa.vue'

// Appaga
import ApPaga from '../views/ApPaga/ApPaga.vue'

// Vantaggi: Benefit Hub, Bonus-X
import BenefitHub from '../views/BenefitHub/BenefitHub.vue'
import BonusXLogin from '../views/BonusX/BonusXLogin.vue'

// Richiesta convenzionamento fornitore
import ConvRequestForm from '../views/ConvRequestForm.vue'

// Assistenza utente
import FaqView from '../views/Assistenza/FaqView.vue'
import FormAssistenza from '../views/Assistenza/FormAssistenza.vue'
import NotificheWb from '../views/Assistenza/NotificheWb.vue'
import TutorialView from '../views/Assistenza/TutorialView.vue'
import FilesDash from '../views/Assistenza/FilesDash.vue'

// Informazioni
import DocumentazioneView from '../views/Informazioni/DocumentazioneView.vue'
import NormativaView from '../views/Informazioni/NormativaView.vue'
import CondServizio from '../views/Informazioni/CondServizio.vue'
import CondPrivacy from '../views/Informazioni/CondPrivacy.vue'

// Sezione dei fornitori
import HomeFornitori from '../views/Fornitori/HomeFornitori.vue'
import VetrinaFornitore from '../views/Fornitori/VetrinaFornitore.vue'
import VetrinaConsorzio from '../views/Fornitori/VetrinaConsorzio.vue'
import VetrinaArticolo from '../views/Fornitori/VetrinaArticolo.vue'
import StatoVoucher from '../views/Fornitori/StatoVoucher.vue'
import GestionePin from '../views/Fornitori/GestionePin.vue'

// Referente Aziendale
import HomeRefAziendale from '../views/HomeRefAziendale.vue'
import ChiaviChain from '../views/RefAziendale/ChiaviChain.vue'
import TabellaConsulenti from '../views/RefAziendale/TabellaConsulenti.vue'
import PiattaPasto from '../views/RefAziendale/PiattaPasto.vue'
import ScadenzarioAzi from '../views/RefAziendale/ScadenzarioAzi.vue'
import PianiWelfare from '../views/RefAziendale/PianiWelfare.vue'
import BuoniPasto from "../views/RefAziendale/BuoniPasto.vue";
import MessInterna from '../views/RefAziendale/MessInterna.vue'
import RefFilesDash from '../views/RefAziendale/RefFilesDash.vue'
import PICDash from '../views/RefAziendale/PICDash.vue'
import GestioneDipendenti from '../views/RefAziendale/GestioneDipendenti.vue'
import ConversionePremio from '../views/RefAziendale/ConversionePremio.vue'
import IncentiveInfo from '../views/RefAziendale/Incentive/IncentiveInfo.vue'
import IncentiveToduba from '../views/RefAziendale/Incentive/IncentiveToduba.vue'
// FIXME: (new stuff) 
import ImportTool from '../views/RefAziendale/ImportTool.vue'

Vue.use(VueRouter)

// Messaggio da far vedere nel caso in cui si sfori il conto anticipi
const c_anticipi_message = "Per motivi tecnici in questo momento non è possibile procedere con l'inserimento di " +
                           "una richiesta: ti invitiamo a voler aprire un ticket di assistenza al fine di consentirci " +
                           "le opportune verifiche.";

// Messaggio da far vedere se ci sono errori nel settare la mappa dei colori del customer
const bad_color_map_message = "Si sono verificati errori nel caricamento della mappa dei colori, l'interfaccia " +
                              "potrebbe non funzionare correttamente. Si prega di riprovare a caricare la pagina, " +
                              "se il problema persiste contattare l'assistenza."


/**
 *  Verifica del customer e persistenza per l'installazione come app e carica nello store
 *  la MAPPA DEI COLORI del customer, siccome la mappa dei colori potrebbe essere presa da
 *  backend la funzione deve essere implementata come una promise:
 *
 *  -- STEP 1: Verifica del customer --
 *  - al primo accesso l'utente proviene dal browser quindi viene eseguito il
 *    codice nel ramo else il quale controlla e setta il customer nello store della app
 *    ed aggiorna di conseguenza il valore nel local storage.
 *    Usando il local storage tale dato rimane persistente nel browser a differenza
 *    del session storage che invece è cancellato ogni volta.
 *  - se lo user installa la app ( e questo viene fatto dopo almeno un accesso da browser
 *    verso l'eventuale link personalizzato ), si esegue il primo blocco di codice dell'if
 *    sottostante perchè dopo l'installazione la app risulta girare come stand-alone,
 *    questo blocco controlla il valore settato nel local storage e lo usa per settare il
 *    customer. Nel caso in cui non ci fosse nessun valore ricadiamo al caso base e viene
 *    settata la skin di default.
 *
 *  -- STEP 2: Caricamento nello store della mappa dei colori del customer. --
 *  - Verifichiamo in prima istanza se il customer settato allo STEP 1 è tra quelli settati
 *    staticamente nel file customerColoMap. Se si carichiamo la mappa nello store e risolviamo
 *    la promise.
 *  - Se non troviamo il customer nella lista statica delle mappe dei colori chiamiamo il
 *    backend per vedere se dato quel customer è presente nel database una mappa delle variabili
 *    per compilare il template base definito per gli api user.
 *    Se presente compiliamo con le variabili prese da backend il template di base per avere
 *    quindi la mappa dei colori dello api user e quindi la memorizziamo nello store.
 *    Risolviamo quindi la promise.
 *  - Se non troviamo nulla anche al backend allora la mappa che stiamo cercando ci caricare non
 *    esiste e diamo quindi un alert.
 *
 *  -- Parametro in ingresso: --
 *  - to: oggetto "to" relativo al path che il router sta gestendo. Ci serve per capire
 *        se il parametro customer è stato passato nell'URL
 */
const customer_control = function ( to ) {


  return new Promise ( ( resolve, reject ) => {

    // *** STEP 1 ***
    // Andiamo in primo luogo a verificare il settaggio della variabile customer
    // sia nel caso dell'installazione della app stand alone che dall'accesso da web.
    if ( generalLib.isChromeStandalone() || generalLib.isIosStandalone() ) {
      // Verifichiamo se il valore nel local storage è stato settato e lo usiamo
      // per settare il customer.
      let storage_customer = localStorage.getItem('wbcustomer');
      if ( storage_customer === null || storage_customer === undefined ) {
        store.commit( 'set_customer', 'default' );
      } else {
        store.commit( 'set_customer', storage_customer );
      }
    } else {
      // Gestiamo la presenza o meno dell'attributo customer, se esiste ed è
      // diverso da null o undefined allora lo settiamo, altrimenti lo mettiamo
      // a default.
      if ( Object.prototype.hasOwnProperty.call( to.params, 'customer' ) &&
          to.params.customer !== undefined && to.params.customer !== null ){
        store.commit( 'set_customer', to.params.customer );
      } else {
        store.commit( 'set_customer', 'default' );
      }

      // Aggiorniamo il valore del customer nel local storage, se non è stato settato o se è diverso
      // dal customer settato in precedenza.
      let storage_customer = localStorage.getItem('wbcustomer');
      if ( ( storage_customer === null && store.state.customer !== null ) ||
          ( storage_customer !== null && storage_customer != store.state.customer ) )
      {
        localStorage.setItem('wbcustomer', store.state.customer);
      }
    }

    // *** STEP 2 ***
    // Ora che abbiamo settato la variabile che definisce il customer andiamo a
    // caricare nelle session infos la mappa dei colori del customer. Verifichiamo
    // prima tra le colorazioni definite in maniera statica nel file, se non trovata
    // andiamo a verificare tra quelle definite dal backend, perchè caricate da
    // un api user esterno.
    if ( Object.prototype.hasOwnProperty.call( customerColorMap.staticskins, store.state.customer ) ) {
      // Setto la mappa nello store e risolvo la promise, poi faccio return per
      // non eseguire la chiamata al backend che altrimenti verrebbe comunque fatta
      store.commit( 'set_customer_color_map', customerColorMap.staticskins[ store.state.customer ] );
      resolve();
      return;
    }

    // Stile non trovato nel file, contatto il backend per prendere la mappa delle varibili
    // se definita al backend.
    let callurl = apiUrl.welfareapi.getapiuserskin.replace( '@customer', store.state.customer );
    axios.get( callurl )
    .then( ( response ) => {
      // Associamo le variabili che costituiscono la mappa dei colori
      // caricate dall'api user al template dell'oggetto che mappa i colori
      // per i componenti per l'intrefaccia e lo stessiamo nello store,
      // poi possiamo risolvere la promise
      let apiuser_skin = customerColorMap.compose_apiuser_skin( response.data.customization );
      store.commit( 'set_customer_color_map', apiuser_skin );
      resolve ();
    })
    .catch( ( error ) => {
      reject( error );
    });

  });

}

/**
 * La funzione controlla se la route al quale vogliamo andare rientra nei permessi degli utenti.
 * Siccome molto spesso questa funzione viene applicata ad un insieme di routes figlie di una route
 * padre, è possibile specificare un'array di route da dare come buone senza controllare se rientranti
 * nei permessi utente.
 * La funzione torna true se la route è permessa, oppure false se non rientra nei permessi utente.
 *
 * - to_route_name: nome della route al quale stiamo tentanto di recarci.
 * - excluded_from_check: array contenente i nomi di eventuali route da escludere dal check. Utile
 *                        nel caso in cui si opera su un unsieme di route figlie di una stessa route padre.
 */
const is_route_permitted = function ( to_route_name, excluded_from_check = [] ) {

  // Supponiamo che la route non sia permessa
  let ok = false;

  // Verifichiamo in prima istanza se la route rientra nei permessi utente.
  if ( store.state.user_perms.indexOf( to_route_name ) != -1 ) {
    // Route permessa, torniamo true
    ok = true;
  } else {
    // Route non permessa, vediamo se da escludere e dare comunque per buona.
    if ( excluded_from_check.indexOf( to_route_name ) != -1 ) {
      // esclusa dal controllo, da dare per buona
      ok = true;
    }
  }

  return ok;
}

const routes = [

  // **** RICONNESSIONE BACKOFFICE ****
  {
    // Esegue la procedura di riconnessione da backoffice. Il parametro
    // "userdata" contiene i dati criptati dell'utente e deve sempre essere
    // presente.
    // Il flag props passa i dati in automatico con l'omonima prop alla view
    // IMPORTANTE:
    // USERDATA DEVE ESSERE URLENCODATO PER EVITARE CHE SI PERDANO I CARATTERI
    // SPECIALI ( , / ? : @ & = + $ # ) VUE FA L'URL DECODING IN AUTOMATICO
    // QUANDO RIPRENDIAMO I PARAMETRI DALLA FUNZIONE "PROPS"
    path: '/reconnect',
    name: 'reconnect',
    component: ReconnectLogin,
    //props: true,
    props : function ( context ) {
      // Prendo i dati utente e li ritorno
      // come prop della component
      let userdata = null;
      if ( Object.prototype.hasOwnProperty.call( context.query, 'd' ) ){
        userdata = context.query.d;
      }
      return { userdata : userdata };
    },
    beforeEnter: (to, from, next) => {

      // Se non esiste il parametro loggingout ( che viene settato solo al click sul pulsante esci della navbar
      // ed indica che voglio effettuare il logout ) e risulto ancora loggato, allora non ho motivo di venire qui,
      // vengo quindi riportato al menu.
      if ( !Object.prototype.hasOwnProperty.call( to.params, 'loggingout' ) && store.state.is_logged ) {
        next( { name : 'menu' } );
        return;
      }

      // Verifica e settings del customer e della sua mappa di colori,
      // vado alla route di login solo se la mappa dei colori viene caricata
      // correttamente altrimenti visualizzo un messaggio.
      // Ad ogni modo in tal caso la mappa dei colori è sempre il default perchè
      // a questa vista il customer non viene passato.
      // Sarà la customer control, non rilevando nessun customer, a settare il
      // default.
      customer_control( to )
      .then( () => {
        next();
      })
      .catch( ( error ) => {
        alert(bad_color_map_message);
        console.error( error );
      });

    }
  },
  // **** LOGIN PER PROVIDER ESTERNO TRAMITE TOKEN ****
  {
    path: '/token-login/:customer*',
    name: 'token-login',
    component: TokenLogin,
    //props: true,
    props : function ( context ) {
      // Prendo il token dalla query string e lo
      // passo al component come property
      let token = null;
      if ( Object.prototype.hasOwnProperty.call( context.query, 't' ) ){
        token = context.query.t;
      }
      return { token : token };
    },
    beforeEnter: (to, from, next) => {

      // Se non esiste il parametro loggingout ( che viene settato solo al click sul pulsante esci della navbar
      // ed indica che voglio effettuare il logout ) e risulto ancora loggato, allora non ho motivo di venire qui,
      // vengo quindi riportato al menu.
      if ( !Object.prototype.hasOwnProperty.call( to.params, 'loggingout' ) && store.state.is_logged ) {
        next( { name : 'menu' } );
        return;
      }

      // Verifica e settings del customer e della sua mappa di colori,
      // vado alla route di login solo se la mappa dei colori viene caricata
      // correttamente altrimenti visualizzo un messaggio.
      customer_control( to )
      .then( () => {
        next();
      })
      .catch( ( error ) => {
        alert(bad_color_map_message);
        console.error( error );
      });

    }
  },
  // **** LOGIN ****
  {
    // Specifichiamo il parametro customer come opzionale, se mancante lo settiamo
    // a "default"
    path: '/login/:customer*',
    name: 'login',
    component: LoginForm,
    props : function ( context ) {
      // Se l'utente proviene da Centro Paghe passa lo user_token
      // in query string. Dobbiamo quindi prenderlo e passarlo al componente
      // per poter gestire il login in SSO.
      let token = null;
      if ( Object.prototype.hasOwnProperty.call( context.query, 'token' ) ){
        token = context.query.token;
      }
      return { cpsso_token : token };
    },
    beforeEnter: (to, from, next) => {

      // Se non esiste il parametro loggingout ( che viene settato solo al click sul pulsante esci della navbar
      // ed indica che voglio effettuare il logout ) e risulto ancora loggato, allora non ho motivo di venire qui,
      // vengo quindi riportato al menu.
      if ( !Object.prototype.hasOwnProperty.call( to.params, 'loggingout' ) && store.state.is_logged ) {
        next( { name : 'menu' } );
        return;
      }

      // Verifica e settings del customer e della sua mappa di colori,
      // vado alla route di login solo se la mappa dei colori viene caricata
      // correttamente altrimenti visualizzo un messaggio.
      customer_control( to )
      .then( () => {
        next();
      })
      .catch( ( error ) => {
        alert(bad_color_map_message);
        console.error( error );
      });

    }
  },
  // **** RECUPERO PASSWORD PERDUTA ****
  // Sia qui che il caso di password scaduta viene utilizzata la vista
  // PasswordReset la quale sa gestire entrambe le casistiche sulla base
  // della prop "form_mode" da settare opportunamente in props.
  {
    path: '/password-lost/:customer*/:token_hash',
    name: 'password-lost',
    component: PasswordReset,
    props: function ( route ) {
      // Oltre a passare come prop il token ricevuto, setta la prop form_mode
      // di modo tale che la vista PasswordReset si comporti opportunamente
      // per il recupero password.
      return { token_hash : route.params.token_hash, form_mode : 'lost' };
    },
    beforeEnter: (to, from, next) => {
      // Verifica e settings del customer e della sua mappa di colori,
      // vado alla route di login solo se la mappa dei colori viene caricata
      // correttamente altrimenti visualizzo un messaggio.
      customer_control( to )
      .then( () => {
        next();
      })
      .catch( ( error ) => {
        alert(bad_color_map_message);
        console.error( error );
      });
    }
  },
  // **** RINNOVO PASSWORD SCADUTA ****
  // Sia qui che il caso di password perdunta viene utilizzata la vista
  // PasswordReset la quale sa gestire entrambe le casistiche sulla base
  // della prop "form_mode" da settare opportunamente in props.
  {
    path: '/password-expired/:customer*/:token_hash',
    name: 'password-expired',
    component: PasswordReset,
    props: function ( route ) {
      // Oltre a passare come prop il token ricevuto, setta la prop form_mode
      // di modo tale che la vista PasswordReset si comporti opportunamente
      // per il rinnovo di una password scaduta.
      return { token_hash : route.params.token_hash, form_mode : 'expired' };
    },
    beforeEnter: (to, from, next) => {
      // Verifica e settings del customer e della sua mappa di colori,
      // vado alla route di login solo se la mappa dei colori viene caricata
      // correttamente altrimenti visualizzo un messaggio.
      customer_control( to )
      .then( () => {
        next();
      })
      .catch( ( error ) => {
        alert(bad_color_map_message);
        console.error( error );
      });
    }
  },
  // **** HOMEPAGE ( ROOT / ) E SOTTOPAGINE DELL'INTERFACCIA ****
  {
    path: '/',
    name: 'home',
    // La root la ridirezioniamo al menù
    // non ha senso vedere la sola pagina con le
    // navbar e nulla dentro.
    redirect: { name: 'menu' },
    component: HomeBase,
    beforeEnter: (to, from, next) => {
      // Se non siamo loggati torniamo al login del customer correntemente attivo
      if ( store.state.is_logged ) {
        next();
        return
      }
      next( { name : 'login', params: { customer: store.state.customer } } )
    },
    children : [
      {
        path: '/menu',
        name: 'menu',
        component: HomeDipendente
      },
      {
        path: '/dashmovimenti',
        name: 'dashmovimenti',
        component: DashMovimenti,
        beforeEnter: (to, from, next) => {
          generalLib.aggiorna_credito_utente();
          next();
        },
        props:  { entity: 'utente' }
      },
      {
        path: '/user-profile',
        name: 'user-profile',
        component: UserProfile
      },
      // ---- FORMS RICHIESTE WELFARE ( /base-request ) ----
      {
        path: '/base-request',
        name : 'base-request',
        component: NestedRouteRoot,
        // Entrando in questo set di pagine controlliamo se l'utente
        // può seguire la route in base ai suoi permessi, se non può
        // viene rimandato alla home.
        // Se invece può seguire la route aggiorniamo il credito utente prima
        // di proseguire.
        beforeEnter: (to, from, next) => {

          if ( !is_route_permitted ( to.name ) ) {
            next( { name : 'menu' } );
            return;
          }

          generalLib.aggiorna_credito_utente();

          next();
        },
        children: [
          {
            // L'eventuale id acquisto da replicare è passato come parametro
            // opzionale ( uso '*' dopo la variabile ), ed impostato come prop
            // della Vista RimborsoSpese ( usando il flag props : true )
            path: 'conv-ondemand/:id_acq_replay*',
            name: 'conv-ondemand',
            component: PreventivoOnDemand,
            props: true,
            beforeEnter: (to, from, next) => {
              // Se la soglia anticipi è sforata torniamo al menu
              if ( store.state.user.threshold_ok ) {
                next();
                return
              }
              alert( c_anticipi_message );
              next( { name : 'menu' } );
            }
          },
          {
            // L'eventuale id acquisto da replicare è passato come parametro
            // opzionale ( uso '*' dopo la variabile ), ed impostato come prop
            // della Vista RimborsoSpese ( usando il flag props : true )
            path: 'rimb-spese/:id_acq_replay*',
            name: 'rimb-spese',
            component: RimborsoSpese,
            props: true
          },
          {
            // L'eventuale id acquisto da replicare è passato come parametro
            // opzionale ( uso '*' dopo la variabile ), ed impostato come prop
            // della Vista RimborsoInteressi ( usando il flag props : true )
            path: 'rimb-interessi/:id_acq_replay*',
            name: 'rimb-interessi',
            component: RimborsoInteressi,
            props: true,
            beforeEnter: (to, from, next) => {
              //Se la soglia anticipi è sforata torniamo al menu
              if ( store.state.user.threshold_ok ) {
                next();
                return
              }
              alert( c_anticipi_message );
              next( { name : 'menu' } );
            }
          },
          {
            // L'eventuale id acquisto da replicare è passato come parametro
            // opzionale ( uso '*' dopo la variabile ), ed impostato come prop
            // della Vista RimborsoBollette ( usando il flag props : true )
            path: 'rimb-bollette/:id_acq_replay*',
            name: 'rimb-bollette',
            component: RimborsoBollette,
            props: true
          },
          {
            // L'eventuale id acquisto da replicare è passato come parametro
            // opzionale ( uso '*' dopo la variabile ), ed impostato come prop
            // della Vista RimborsoBollette ( usando il flag props : true )
            path: 'rimb-aff-mutui/:id_acq_replay*',
            name: 'rimb-aff-mutui',
            component: RimborsoAffMutui,
            props: true
          },
          {
            // L'eventuale id acquisto da replicare è passato come parametro
            // opzionale ( uso '*' dopo la variabile ), ed impostato come prop
            // della Vista RimborsoSpese ( usando il flag props : true )
            path: 'conv-previdenza-integrativa/:id_acq_replay*',
            name: 'conv-previdenza-integrativa',
            component: PrevidenzaIntegrativa,
            props: true
          }
        ]
      },
      // ---- TANTOSVAGO ( /ts )----
      // Pagine di login ai servizi di tantosvago, le riuniamo tutte in
      // un unico sottopath.
      {
        path: '/ts',
        name: 'ts',
        component: NestedRouteRoot,
        beforeEnter: (to, from, next) => {

          // Controlliamo prima della soglia, se la route è permessa.
          // La route 'return-url' la escludiamo perchè non viene permissionata,
          // è quella eventualmente da utilizzare per il ritorno da tantosvago
          // verso il nostro portale, per il momento non è neanche usata.
          let do_not_check = ['return-url'];
          if ( !is_route_permitted ( to.name, do_not_check ) ) {
            next( { name : 'menu' } );
            return;
          }

          // Se la soglia anticipi è sforata torniamo al menu
          // altrimenti aggiorniamo il credito utente e proseguiamo
          if ( store.state.user.threshold_ok ) {
            generalLib.aggiorna_credito_utente();
            next();
            return
          }

          alert( c_anticipi_message );

          next( { name : 'menu' } );
        },
        children : [
          {
            path: 'conv-attive',
            name: 'conv-attive',
            component: TsExperience,
          },
          {
            path: 'conv-viaggi',
            name: 'conv-viaggi',
            component: TsTravel,
          },
          {
            path: 'conv-viaggi-b',
            name: 'conv-viaggi-b',
            component: TsTravelB,
          },
          {
            path: 'conv-giftcard',
            name: 'conv-giftcard',
            component: TsGiftcard,
          },
          {
            path: 'conv-gowelfare',
            name: 'conv-gowelfare',
            component: TsGoWelfare,
          },
          {
            path: 'conv-ticket',
            name: 'conv-ticket',
            component: TsTicket,
          },
          {
            path: 'conv-amazon-libri',
            name: 'conv-amazon-libri',
            component: TsAmzLibri,
          },
          {
            path: 'conv-home-activities',
            name: 'conv-home-activities',
            component: TsHomeActivities,
          },
          {
            path: 'conv-assirete',
            name: 'conv-assirete',
            component: TsAssirete,
          },
          {
            path: 'conv-welcometoitaly',
            name: 'conv-welcometoitaly',
            component: TsWelcomeToItaly,
          },
          {
            path: 'conv-snowit',
            name: 'conv-snowit',
            component: TsSnowIt,
          },
          {
            path: 'conv-eatinerari',
            name: 'conv-eatinerari',
            component: TsEatinerari,
          },
          {
            path: 'conv-edicola',
            name: 'conv-edicola',
            component: TsEdicola,
          }
        ]
      },
      // ---- Wishlist ( /ws )----
      // Pagine dei buoni wishlist ( buoni welfarebit )
      {
        path: '/ws',
        name: 'ws',
        component: NestedRouteRoot,
        beforeEnter: (to, from, next) => {

          // Prima della soglia anticipi controlliamo se la route
          // verso il quale stiamo andando è permissionata altrimenti
          // torniamo al menù
          if ( !is_route_permitted ( to.name ) ) {
            next( { name : 'menu' } );
            return;
          }

          // Se la soglia anticipi è sforata torniamo al menu
          // altrimenti aggiorniamo il credito utente e
          // proseguiamo.
          if ( store.state.user.threshold_ok ) {
            generalLib.aggiorna_credito_utente();
            next();
            return
          }

          alert( c_anticipi_message );

          next( { name : 'menu' } );
        },
        children : [
          {
            path: 'conv-wishlist',
            name: 'conv-wishlist',
            component: WishListLogin,
          }
        ]
      },
      // ---- Amilon ( /aml )----
      // Pagine dei buoni Amilon
      {
        path: '/aml',
        component: NestedRouteRoot,
        beforeEnter: (to, from, next) => {

          // Controlliamo prima se la parte Amilon è permissionata
          // siccome le singole pagine dei fornitori devono essere
          // accessibili se è stata permissionata la home, dove trovano
          // posto tutti i fornitori, passiamo alla funzione NON la
          // route verso il quale stiamo andando, ma la home con i
          // fornitori Amilon in maniera statica.
          if ( !is_route_permitted ( 'conv-aml' ) ) {
            next( { name : 'menu' } );
            return;
          }

          // Se la soglia anticipi è sforata torniamo al menu
          // altrimenti aggiorniamo il credito utente e
          // proseguiamo.
          if ( store.state.user.threshold_ok ) {
            generalLib.aggiorna_credito_utente();
            next();
            return
          }

          alert( c_anticipi_message );

          next( { name : 'menu' } );
        },
        children : [
          {
            path: 'conv-aml',
            name: 'conv-aml',
            component: HomeAmilon
          },
          {
            // L'id del fornitore da visualizzare è passato come parametro
            // ( non opzionale ma mandatorio non c'è il '*' ) ed impostato come
            // prop per la vista usando il flag props: true
            path: 'forn-aml/:id_fornitore',
            name: 'forn-aml',
            component: VetrinaFornAmilon,
            props: true
          }
        ]
      },

      // ---- Bonus Benzina ----
      // Pagina relativa all'erogazione del bonus benzina 2022.
      // Anche se si tratta di un servizio Erogato da Amilon
      // la mettiamo come route separata perchè di fatto è un'altra
      // cosa.
      {
        path: '/bonus-benzina',
        name: 'bonus-benzina',
        component: BonusCarburante,
        beforeEnter: (to, from, next) => {

          // Controlliamo prima della soglia, se la route è permessa.
          if ( !is_route_permitted ( to.name ) ) {
            next( { name : 'menu' } );
            return;
          }

          // Se la soglia anticipi è sforata torniamo al menu
          // altrimenti aggiorniamo il credito utente e proseguiamo
          if ( store.state.user.threshold_ok ) {
            generalLib.aggiorna_credito_utente();
            next();
            return
          }

          alert( c_anticipi_message );

          next( { name : 'menu' } );
        }
      },

      // ---- amilon100 ----
      // Pagine di login verso i servizi amilon100
      {
        path: '/aml100',
        name: 'aml100',
        component: NestedRouteRoot,
        beforeEnter: (to, from, next) => {

          // Controlliamo prima della soglia, se la route è permessa.
          if ( !is_route_permitted ( to.name ) ) {
            next( { name : 'menu' } );
            return;
          }

          // Se la soglia anticipi è sforata torniamo al menu
          // altrimenti aggiorniamo il credito utente e proseguiamo
          if ( store.state.user.threshold_ok ) {
            generalLib.aggiorna_credito_utente();
            next();
            return
          }

          alert( c_anticipi_message );

          next( { name : 'menu' } );
        },
        children : [
          {
            path: 'conv-aml-expedia',
            name: 'conv-aml-expedia',
            component: AmlExpedia
          },
          {
            path: 'conv-aml-hoepli',
            name: 'conv-aml-hoepli',
            component: AmlHoepli
          }
        ]
      },

      // ---- Eurete ( /eurete )----
      // Pagine dei sussidi Eurete
      {
        path: '/eurete',
        component: NestedRouteRoot,
        beforeEnter: (to, from, next) => {

          // Controlliamo se Eurete è permissionata.
          // Siccome le singole sezioni devono essere accessibili se
          // è permissionata la parte della home, NON mettiamo la
          // route verso il quale stiamo andando ma la home con la
          // lista delle sezioni in modo statico.
          if ( !is_route_permitted ( 'conv-eurete-buoni' ) && !is_route_permitted ( 'conv-eurete-100' ) ) {
            next( { name : 'menu' } );
            return;
          }

          // Se la soglia anticipi è sforata torniamo al menu
          // altrimenti aggiorniamo il credito utente e
          // proseguiamo.
          if ( store.state.user.threshold_ok ) {
            generalLib.aggiorna_credito_utente();
            next();
            return
          }

          alert( c_anticipi_message );

          next( { name : 'menu' } );

        },
        children : [
          // Il path al link nella parte buoni è un redirect
          // alla pagina principale delle convenzioni.
          {
            path: 'conv-eurete-buoni',
            name: 'conv-eurete-buoni',
            component: HomeEurete
          },
          {
            // Lo slug_name della sezione da mostrare è passato come parametro
            // ( non opzionale ma mandatorio non c'è il '*' ) ed impostato come
            // prop per la vista usando il flag props: true
            path: 'sez-eurete/:slug_name',
            name: 'sez-eurete',
            component: VetrinaEurete,
            props: true
          },
          {
            path: 'conv-eurete-100',
            name: 'conv-eurete-100',
            component: VetrinaEurete100,
            props: true
          }
        ]
      },

      // ---- FANO AL CENTRO ----
      // Pagina di login verso il portale di Fano Al Centro
      {
        path: '/conv-fac',
        name: 'conv-fac',
        component: FacLoginPage,
        beforeEnter: (to, from, next) => {

          // Controlliamo prima della soglia, se la route è permessa.
          if ( !is_route_permitted ( to.name ) ) {
            next( { name : 'menu' } );
            return;
          }

          // Se la soglia anticipi è sforata torniamo al menu
          // altrimenti aggiorniamo il credito utente e proseguiamo
          if ( store.state.user.threshold_ok ) {
            generalLib.aggiorna_credito_utente();
            next();
            return
          }

          alert( c_anticipi_message );

          next( { name : 'menu' } );
        }
      },

      // ---- MBA ----
      // Pagina di login verso il portale di MBA
      {
        path: '/conv-mba',
        name: 'conv-mba',
        component: MBALoginPage,
        beforeEnter: (to, from, next) => {

          // Controlliamo prima della soglia, se la route è permessa.
          if ( !is_route_permitted ( to.name ) ) {
            next( { name : 'menu' } );
            return;
          }

          // Se la soglia anticipi è sforata torniamo al menu
          // altrimenti aggiorniamo il credito utente e proseguiamo
          if ( store.state.user.threshold_ok ) {
            generalLib.aggiorna_credito_utente();
            next();
            return
          }

          alert( c_anticipi_message );

          next( { name : 'menu' } );
        }
      },

      // ---- Salute Semplice ----
      // Pagina di login verso il portale di Salute Semplice
      {
        path: '/conv-salute-semplice',
        name: 'conv-salute-semplice',
        component: SaluteSempliceLoginPage,
          beforeEnter: (to, from, next) => {

              // Controlliamo prima della soglia, se la route è permessa.
              if ( !is_route_permitted ( to.name ) ) {
                  next( { name : 'menu' } );
                  return;
              }

              // Se la soglia anticipi è sforata torniamo al menu
              // altrimenti aggiorniamo il credito utente e proseguiamo
              if ( store.state.user.threshold_ok ) {
                  generalLib.aggiorna_credito_utente();
                  next();
                  return
              }

              alert( c_anticipi_message );

              next( { name : 'menu' } );
          },
      },

      // ---- BITQ ----
      // Pagine di login verso i servizi BitQ
      {
        path: '/bitq',
        name: 'bitq',
        component: NestedRouteRoot,
        beforeEnter: (to, from, next) => {

          // Controlliamo prima della soglia, se la route è permessa.
          if ( !is_route_permitted ( to.name ) ) {
            next( { name : 'menu' } );
            return;
          }

          // Se la soglia anticipi è sforata torniamo al menu
          // altrimenti aggiorniamo il credito utente e proseguiamo
          if ( store.state.user.threshold_ok ) {
            generalLib.aggiorna_credito_utente();
            next();
            return
          }

          alert( c_anticipi_message );

          next( { name : 'menu' } );
        },
        children : [
          {
            path: 'conv-bitq-parchi',
            name: 'conv-bitq-parchi',
            component: BitQParchi
          },
          {
            path: 'conv-bitq-exp',
            name: 'conv-bitq-exp',
            component: BitQEsperienze
          },
          {
            path: 'conv-bitq-tour',
            name: 'conv-bitq-tour',
            component: BitQTour
          },
          {
            path: 'conv-bitq-sport',
            name: 'conv-bitq-sport',
            component: BitQSport
          },
          {
            path: 'conv-bitq-musei',
            name: 'conv-bitq-musei',
            component: BitQMusei
          },
          {
            path: 'conv-bitq-cinema',
            name: 'conv-bitq-cinema',
            component: BitQCinema
          },
          {
            path: 'conv-bitq-concerti',
            name: 'conv-bitq-concerti',
            component: BitQConcerti
          },
          {
            path: 'conv-bitq-gaming',
            name: 'conv-bitq-gaming',
            component: BitQGaming
          },
          {
            path: 'conv-bitq-corsi',
            name: 'conv-bitq-corsi',
            component: BitQCorsi
          }
        ]
      },

      // ---- SALABAM ----
      // Pagine di login verso i servizi Salabam
      {
        path: '/salabam',
        name: 'salabam',
        component: NestedRouteRoot,
        beforeEnter: (to, from, next) => {

          // Controlliamo prima della soglia, se la route è permessa.
          if ( !is_route_permitted ( to.name ) ) {
            next( { name : 'menu' } );
            return;
          }

          // Se la soglia anticipi è sforata torniamo al menu
          // altrimenti aggiorniamo il credito utente e proseguiamo
          if ( store.state.user.threshold_ok ) {
            generalLib.aggiorna_credito_utente();
            next();
            return
          }

          alert( c_anticipi_message );

          next( { name : 'menu' } );
        },
        children : [
          {
            path: 'conv-salabam-shop',
            name: 'conv-salabam-shop',
            component: SalabamShop
          },
          {
                path: 'conv-booking',
                name: 'conv-booking',
                component: SalabamBooking,
          },
          {
            path: 'conv-salabam-vadobay',
            name: 'conv-salabam-vadobay',
            component: SalabamVadobay
          },
          {
            path: 'conv-salabam-voli-vadobay',
            name: 'conv-salabam-voli-vadobay',
            component: SalabamVoliVadobay
          },
          {
            path: 'conv-salabam-travel-train',
            name: 'conv-salabam-travel-train',
            component: SalabamTravelTrain
          },
          {
            path: 'conv-salabam-vacanze-vadobay',
            name: 'conv-salabam-vacanze-vadobay',
            component: SalabamVacanzeVadobay
          },
          {
            path: 'conv-salabam-vivamod',
            name: 'conv-salabam-vivamod',
            component: SalabamVivamod
          },
          {
            path: 'conv-salabam-wiaggiare',
            name: 'conv-salabam-wiaggiare',
            component: SalabamWiaggiare
          }
        ]
      },

      // ---- OLLIPAY ----
      // Pagine di login verso i servizi Ollipay
      {
        path: '/ollipay',
        name: 'ollipay',
        component: NestedRouteRoot,
        beforeEnter: (to, from, next) => {

          // Controlliamo prima della soglia, se la route è permessa.
          // In questo caso con Ollipay controlliamo oltre al permesso
          // di menù welfarebit anche che l'utente sia registrato ad Ollipay.
          if ( !is_route_permitted ( to.name ) || !store.state.user.ollipay_status.reg_status ) {
            next( { name : 'menu' } );
            return;
          }

          // Se la soglia anticipi è sforata torniamo al menu
          // altrimenti aggiorniamo il credito utente e proseguiamo
          if ( store.state.user.threshold_ok ) {
            generalLib.aggiorna_credito_utente();
            next();
            return
          }

          alert( c_anticipi_message );

          next( { name : 'menu' } );
        },
        children : [
          {
            path: 'conv-ollipay',
            name: 'conv-ollipay',
            component: OlliPay
          }
        ]
      },

      // ---- TODUBA ----
      // Pagine di login verso i buoni toduba
      {
        path: '/toduba',
        name: 'toduba',
        component: NestedRouteRoot,
        beforeEnter: (to, from, next) => {

          // Controlliamo prima della soglia, se la route è permessa.
          if ( !is_route_permitted ( to.name ) ) {
            next( { name : 'menu' } );
            return;
          }

          // Se la soglia anticipi è sforata torniamo al menu
          // altrimenti aggiorniamo il credito utente e proseguiamo
          if ( store.state.user.threshold_ok ) {
            generalLib.aggiorna_credito_utente();
            next();
            return
          }

          alert( c_anticipi_message );

          next( { name : 'menu' } );
        },
        children : [
          {
            path: 'conv-toduba',
            name: 'conv-toduba',
            component: ToDuBa
          }
        ]
      },

      // ---- APPAGA ----
      // Pagine di login verso i buoni appaga
      {
        path: '/appaga',
        name: 'appaga',
        component: NestedRouteRoot,
        beforeEnter: (to, from, next) => {

          // Controlliamo prima della soglia, se la route è permessa.
          if ( !is_route_permitted ( to.name ) ) {
            next( { name : 'menu' } );
            return;
          }

          // Se la soglia anticipi è sforata torniamo al menu
          // altrimenti aggiorniamo il credito utente e proseguiamo
          if ( store.state.user.threshold_ok ) {
            generalLib.aggiorna_credito_utente();
            next();
            return
          }

          alert( c_anticipi_message );

          next( { name : 'menu' } );
        },
        children : [
          {
            path: 'conv-appaga',
            name: 'conv-appaga',
            component: ApPaga
          }
        ]
      },
      // ---- BENEFIT PER GLI UTENTI ( /benefits ) ----
      {
        path: '/benefits',
        name: 'benefits',
        component: NestedRouteRoot,
        beforeEnter: (to, from, next) => {

          // Controlliamo prima se la route è permessa
          // altrimenti torniamo al menù
          // Qui non viene usato il credito quindi non dobbiamo
          // controllar eil conto anticipi.
          if ( !is_route_permitted ( to.name ) ) {
            next( { name : 'menu' } );
            return;
          }

          // Anche se qui non si userà il credito utente
          // per mantenere comunque aggiornato popup del
          // credito e la relativa variabile interna, lo
          // aggiorniamo e poi precediamo.
          generalLib.aggiorna_credito_utente();
          next();
        },
        children: [
          // ---- BENEFIT HUB ----
          // Pagina di presentazione e link al servizio benefit hub.
          {
            path: 'benefit-hub',
            name: 'benefit-hub',
            component: BenefitHub
          },
          // ---- BONUS X ----
          // Pagina di presentazione ed accesso al servizio bonus-x.
          {
            path: 'conv-bonusx',
            name: 'conv-bonusx',
            component: BonusXLogin
          }
        ]
      },

      // ---- APERTURA FORM RICHIESTA CONVENZIONE FORNITORE ( /conv-request-form )----
      // Una pagina "ponte" che ha il solo scopo di aprire il form hubspot per la richiesta
      // di convenzionamento di un fornitore da parte di un utente.
      {
        path: '/conv-request-form',
        name: 'conv-request-form',
        component: ConvRequestForm,
        beforeEnter: (to, from, next) => {

          if ( !is_route_permitted ( to.name ) ) {
            next( { name : 'menu' } );
            return;
          }

          // In questo caso non c'è bisogno di aggiornare la disponibilità di credito
          // perchè non ci sono operazioni di acquisto.
          next();

        }
      },

      // ---- ASSISTENZA UTENTE ( /helpdesk )----
      // Pagine dedicate ai servizi di assistenza all'uttente
      {
        path: '/helpdesk',
        name: 'helpdesk',
        component: NestedRouteRoot,
        beforeEnter: (to, from, next) => {
          // Controlliamo prima se la route è permessa
          // altrimenti torniamo al menù
          if ( !is_route_permitted ( to.name ) ) {
            next( { name : 'menu' } );
            return;
          }
          next();
        },
        children: [
          {
            path: 'site-faq',
            name: 'site-faq',
            component: FaqView
          },
          {
            path: 'site-assistenza',
            name: 'site-assistenza',
            component: FormAssistenza
          },
          {
            path: 'site-notifiche',
            name: 'site-notifiche',
            component: NotificheWb
          },
          {
            path: 'site-tutorial',
            name: 'site-tutorial',
            component: TutorialView
          },
          {
            path: 'site-archivio-files',
            name: 'site-archivio-files',
            component: FilesDash
          }
        ]
      },
      // ---- INFORMAZIONI ( /infos ) ----
      {
        path: '/infos',
        name: 'infos',
        component: NestedRouteRoot,
        beforeEnter: (to, from, next) => {
          // Controlliamo prima se la route è permessa
          // altrimenti torniamo al menù
          if ( !is_route_permitted ( to.name ) ) {
            next( { name : 'menu' } );
            return;
          }
          next();
        },
        children: [
          {
            path: 'site-documentazione/:group_to_show*',
            name: 'site-documentazione',
            component: DocumentazioneView,
            props: true
          },
          {
            path: 'site-normativa',
            name: 'site-normativa',
            component: NormativaView
          },
          {
            path: 'cond-servizio',
            name: 'cond-servizio',
            component: CondServizio
          },
          {
            path: 'cond-privacy',
            name: 'cond-privacy',
            component: CondPrivacy
          }
        ]
      },
      // ---- SEZIONE DEI FORNITORI ( /sellers ) ----
      {
        path: '/sellers',
        name: 'sellers',
        component: NestedRouteRoot,
        beforeEnter: (to, from, next) => {

          // Controlliamo prima se la parte dei fornitori
          // è permissionata, siccome le pagine della vetrina
          // devono essere accessibili se è stata permissionata
          // l'area fornitori, quindi la home, passiamo alla funzione
          // NON la route verso dove stiamo andando, ma la home-fornitori
          // in maniera statica.
          if ( !is_route_permitted ( 'home-fornitori' ) ) {
            next( { name : 'menu' } );
            return;
          }

          // Se la soglia anticipi è sforata torniamo al menu
          // altrimenti aggiorniamo il credito utente e proseguiamo
          if ( store.state.user.threshold_ok ) {
            generalLib.aggiorna_credito_utente();
            next();
            return
          }

          alert( c_anticipi_message );

          next( { name : 'menu' } );
        },
        children: [
          {
            path: 'home-fornitori',
            name: 'home-fornitori',
            component: HomeFornitori
          },
          {
            // L'id del fornitore da visualizzare è passato come parametro
            // ( non opzionale ma mandatorio non c'è il '*' ) ed impostato come
            // prop per  la vista usando il flag props: true
            path: 'vetrina-fornitore/:id_fornitore',
            name: 'vetrina-fornitore',
            component: VetrinaFornitore,
            props: true
          },
          {
            // L'id del consorzio da visualizzare è passato come parametro
            // ( non opzionale ma mandatorio non c'è il '*' ) ed impostato come
            // prop per la vista usando il flag props: true
            path: 'vetrina-consorzio/:id_consorzio',
            name: 'vetrina-consorzio',
            component: VetrinaConsorzio,
            props: true
          },
          {
            // L'id dell'articolo da visualizzare è passato come parametro
            // ( non opzionale ma mandatorio non c'è il '*' ) ed impostato come
            // prop per  la vista usando il flag props: true
            path: 'vetrina-articolo/:id_articolo',
            name: 'vetrina-articolo',
            component: VetrinaArticolo,
            props: true
          },
          {
            path: 'stato-voucher',
            name: 'stato-voucher',
            component: StatoVoucher
          },
          {
            path: 'gestione-pin',
            name: 'gestione-pin',
            component: GestionePin
          }
        ]
      },
      // ---- SEZIONE DEL REFERENTE AZIENDALE ( /backoffice-refazi ) ----
      // Tutte le viste sotto questa root comune triggerano l'invio dell'header
      // Act-For al backend se il referente aziendale deve visualizzare dati di
      // un'altra azienda da lui gestita ( vedi interceptor axios in main.js ).
      {
        path: '/backoffice-refazi',
        name: 'backoffice-refazi',
        component: NestedRouteRoot,
        // Come ulteriore sicurezza contro eventuali utenti che conoscono
        // il path anche se non hanno i pulsanti abilitati, andiamo ai
        // servizi del referente aziendale solo se il profilo è quello corretto
        beforeEnter: (to, from, next) => {
          if ( store.state.user.profile === 'ref_aziendale' ) {

            // Se l'utente è un referente controlliamo quindi che acceda alle sole
            // route a lui permissionate, escludiamo la home dal controllo perchè non
            // è permissionabile e cmq accessibile solo se arriviamo qui, cioè se siamo
            // un referente, infatti poi torniamo verso di lei se siamo qui, e non
            // alla pagina di menù
            if ( !is_route_permitted ( to.name, ['home-refazi'] ) ) {
              next( { name : 'home-refazi' } );
              return;
            }

            next();

          } else {
            next( { name : 'menu' } );
          }
        },
        children: [
          {
            path: 'home-refazi',
            name: 'home-refazi',
            component: HomeRefAziendale
          },
          {
            path: 'office-transactionsdash',
            name: 'office-transactionsdash',
            component: DashMovimenti,
            props:  { entity: 'azienda' }
          },
          {
            path: 'office-scadenzario-azi',
            name: 'office-scadenzario-azi',
            component: ScadenzarioAzi
          },
          {
            path: 'office-piattapasto',
            name: 'office-piattapasto',
            component: PiattaPasto
          },
          {
            path: 'office-cifratura-chain',
            name: 'office-cifratura-chain',
            component: ChiaviChain
          },
          {
            path: 'office-import-anagrafiche-crediti',
            name: 'office-import-anagrafiche-crediti',
            component: ImportTool
          },
          {
            path: 'office-ref-azi-piani-welfare',
            name: 'office-ref-azi-piani-welfare',
            component: PianiWelfare
          },
          {
            path: 'office-ref-azi-buoni-pasto',
            name: 'office-ref-azi-buoni-pasto',
            component: BuoniPasto
          },
          {
            path: 'office-consulenti',
            name: 'office-consulenti',
            component: TabellaConsulenti
          },
          {
            path: 'office-mess-interna',
            name: 'office-mess-interna',
            component: MessInterna
          },
          {
            path: 'office-user-files',
            name: 'office-user-files',
            component: RefFilesDash
          },
          {
            path: 'office-PICdash',
            name: 'office-PICdash',
            component: PICDash
          },
          {
            path: 'office-gestione-dipendenti',
            name: 'office-gestione-dipendenti',
            component: GestioneDipendenti
          },
          {
            path: 'office-conversione-premio',
            name: 'office-conversione-premio',
            component: ConversionePremio
          },
          {
            // All'area incentive dedichiamo un sotto path
            // specifico per le pagine che la compongono.
            // Eredita il check dei permessi dalla root
            // di "backoffice-refazi", non c'è quindi bisogno
            // di ribardirla qui.
            path: 'incentive',
            name: 'incentive',
            component: NestedRouteRoot,
            children: [
              {
                path: 'office-incentive-info',
                name: 'office-incentive-info',
                component: IncentiveInfo
              },
              {
                path: 'office-incentive-toduba',
                name: 'office-incentive-toduba',
                component: IncentiveToduba
              }
            ]
          }
        ]
      },
      // ---- REDIRECT A HOME DOPO APERTURA CONVENZIONI ----
      // Dopo che viene aperta una pagina di un fornitore
      // in convezione per la quale l'acquisto è gestisto
      // con l'accesso in SSO al suo portale, portiamo l'utente
      // qui e quindi alla home per non farlo rimanere nella
      // pagina che ha aperto il portale del fornitore.
      // Il parametro props è true perchè dalla pagina da
      // cui provengo posso passare il titolo del servizio cui
      // ho acceduto.
      {
        path: 'conv-redirect',
        name: 'conv-redirect',
        component: ConvRedirect,
        props : true
      },
      // ---- PAGINA NON TROVATA ----
      {
        path: "*",
        component: PageNotFound
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Facciamo in modo che ad ogni cambio di route la pagina
    // riparta dall'alto.
    return { x: 0, y: 0 }
  }
})


export default router
